import React from 'react'
import { arrayOf, bool, func, string, oneOfType } from 'prop-types'
import classnames from 'classnames'

const SearchResultsItem = ({ id, text, active, onClick }) => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  <li
    className={classnames('search__results-item', { active })}
    onClick={onClick}
    key={id}
  >
    <span dangerouslySetInnerHTML={{ __html: text }}/>
    <style jsx global>
      {`
        .search__results-item {
          padding: 16px;
          font-size: 16px;
          cursor: pointer;
          &.active, &:hover {
            background-color: rgb(227, 236, 245);
          }
        }
      `}
    </style>
  </li>
)

SearchResultsItem.propTypes = {
  id: string,
  onClick: func,
  text: oneOfType([arrayOf(string), string]),
  active: bool,
}

export default SearchResultsItem
